import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "./ProductsChart.css";

const ProductsChart = ({ productData = [] }) => {
  const formattedSizes = Array.isArray(productData) ? productData.map((item) => item.size + '"') : [];
  const counterfeitData = Array.isArray(productData) ? productData.map((item) => item.percentage) : [];
  const genuineData = Array.isArray(productData) ? productData.map((item) => 100 - item.percentage) : [];
  const percentageLabels = Array.isArray(productData) ? productData.map((item) => `${item.percentage}%`) : [];
 
  const barHeight = 25; // Approximate height per bar
  const chartHeight = Math.max(300, productData.length * barHeight); // Dynamic height

  console.log("productData", productData);
  const options = {
    chart: {
      type: "bar",
      height: chartHeight,
    },
    title: {
      text: "",
    },
    xAxis: [
      {
        categories: formattedSizes,
        labels: {
          className: "products-chart-label",
          align: "right",
          x: -10,
          y: 3,
          reserveSpace: true,   
        },
        lineWidth: 0,
        offset: 0,
      },
      {
        opposite: true,
        linkedTo: 0,
        categories: percentageLabels,
        labels: {
          formatter: function () {
            return this.value;
          },
          className: "products-chart-label-bold",
          align: "left",
          x: 5,
          y: 3,
          reserveSpace: true,
        },
        lineWidth: 0,
        offset: 0,
      },
    ],
    yAxis: {
      min: 0,
      max: 100,
      title: {
        text: null,
      },
      labels: {
        enabled: false,
      },
      gridLineWidth: 0,
      lineWidth: 0,
    },
    plotOptions: {
      series: {
        stacking: "normal",
        pointWidth: 20,
        groupPadding: 1.05,
        borderRadius: 0,
      },
      bar: {
        dataLabels: {
          enabled: false,
        },
      },
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      formatter: function () {
        const index = this.point.index;
        const data = productData[index];
    
        if (this.series.name === "Genuine") {
          return `

            <b>Genuine:</b> ${data?.genuine_count}
          `;
        } else if (this.series.name === "Counterfeit") {
          return `
            <b>Counterfeit:</b> ${data?.counterfeit_count}
          `;
        }
    
        return null;
      },
    },
    series: [
      {
        name: "Counterfeit",
        data: counterfeitData.map((value, index) => {
          const data = productData[index];
          const totalCount = (data?.genuine_count || 0) + (data?.counterfeit_count || 0);
          return {
            y: value,
            color: totalCount == 0 ? '#888888' : {
              linearGradient: {
                x1: 0,
                x2: 0,
                y1: 0,
                y2: 1,
              },
              stops: [
                [0, "#c22b2b"],
                [1, "#c22b2b"],
              ],
            }
          };
        }),
        borderRadius: {
          radius: 50,
          scope: "stack",
        },
      },
      {
        name: "Genuine",
        data: genuineData.map((value, index) => {
          const data = productData[index];
          const totalCount = (data?.genuine_count || 0) + (data?.counterfeit_count || 0);
          return {
            y: value,
            color: totalCount == 0 ? '#888888' : {
              linearGradient: {
                x1: 0,
                x2: 0,
                y1: 0,
                y2: 1,
              },
              stops: [
                [0, "#128737"],
                [1, "#128737"],
              ],
            }
          };
        }),
        borderRadius: {
          radius: 50,
          scope: "stack",
        },
      },
    ],
  };

  return (
    <div className="scroll-container-left-scrollbar">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default ProductsChart;
